<template>
  <v-layout row wrap>
    <v-flex xs5>
      <v-text-field v-model="receiptHeader1" label="Header Line 1"></v-text-field>
      <v-text-field v-model="receiptHeader2" label="Header Line 2"></v-text-field>
      <v-text-field v-model="receiptHeader3" label="Header Line 3"></v-text-field>
      <v-text-field v-model="receiptHeader4" label="Header Line 4"></v-text-field>
      <v-text-field v-model="receiptHeader5" label="Header Line 5"></v-text-field>
    </v-flex>

    <v-flex xs1></v-flex>

    <v-flex xs5>
      <v-text-field v-model="receiptFooter1" label="Footer Line 1"></v-text-field>
      <v-text-field v-model="receiptFooter2" label="Footer Line 2"></v-text-field>
      <v-text-field v-model="receiptFooter3" label="Footer Line 3"></v-text-field>
      <v-text-field v-model="receiptFooter4" label="Footer Line 4"></v-text-field>
      <v-text-field v-model="receiptFooter5" label="Footer Line 5"></v-text-field>
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  name: 'OrderDetailReceipt',
  computed: {
    receiptHeader1: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptHeader1)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptHeader1', value])
      }
    },
    receiptHeader2: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptHeader2)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptHeader2', value])
      }
    },
    receiptHeader3: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptHeader3)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptHeader3', value])
      }
    },
    receiptHeader4: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptHeader4)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptHeader4', value])
      }
    },
    receiptHeader5: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptHeader5)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptHeader5', value])
      }
    },
    receiptFooter1: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptFooter1)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptFooter1', value])
      }
    },
    receiptFooter2: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptFooter2)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptFooter2', value])
      }
    },
    receiptFooter3: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptFooter3)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptFooter3', value])
      }
    },
    receiptFooter4: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptFooter4)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptFooter4', value])
      }
    },
    receiptFooter5: {
      get () {
        return this.checkBlank(this.$store.state.order.receiptFooter5)
      },
      set (value) {
        this.$store.commit('updateOrder', ['receiptFooter5', value])
      }
    }
  },
  methods: {
    checkBlank: (val) => {
      if (val === undefined) { val = '' }
      if (val === '') { val = '' }
      if (val === 'undefined') { val = '' }
      if (val === null) { val = '' }
      return val
    }
  }
}
</script>

<style scoped>

</style>
